<template>
  <div class="auth-header">
    <button
      v-if="showBack"
      type="button"
      class="auth-header__icon-btn"
      :aria-label="$t('profile.auth.back')"
      @click="$emit('back')">
      <ChevronLeft :size="20" />
    </button>
    <span v-else class="auth-header__spacer"></span>

    <button
      type="button"
      class="auth-header__icon-btn"
      :aria-label="$t('profile.auth.close')"
      @click="$emit('close')">
      <X :size="20" />
    </button>
  </div>
</template>

<script>
  import { ChevronLeft, X } from 'lucide-vue';

  export default {
    name: 'AuthModalHeader',
    components: {
      ChevronLeft,
      X
    },
    props: {
      showBack: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
.auth-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 12px;
}
.auth-header__icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: #6B7886;
  background: #F3F6F9;
  border: none;
  border-radius: 999px;
  cursor: pointer;
}
.auth-header__icon-btn:hover {
  color: #1C2B36;
}
.auth-header__spacer {
  width: 36px;
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/auth/AuthModalHeader.vue